import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Icon from '../../../../../shared/_TBComponents/Icon';
import Input from '../../../../../shared/_TBComponents/Input';
import Text from '../../../../../shared/_TBComponents/Text';

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const AvailabilityRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

const AvailabilitySquare = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 110px;
  height: 120px;
  padding: 10px 0;
  border-radius: 4px;
  border: 1px solid ${(props) => (props.isChecked ? '#0DCC8A' : '#D0D0D0')};
  background: #FFFFFF;
  box-shadow: 0 1px 3px 0 rgba(48, 49, 51, 0.10), 0 0 1px 0 rgba(48, 49, 51, 0.05);
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: #0DCC8A;
  }
`;

const AvailabilityIconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${(props) => (props.isChecked ? '#0DCC8A1A' : 'transparent')};
`;

const CheckCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid ${(props) => (props.isChecked ? '#0DCC8A' : '#D0D0D0')};
  background: ${(props) => (props.isChecked ? '#0DCC8A' : 'transparent')};
`;

const AVAILABILITY_OPTIONS = [
  { key: 'messaging', label: 'Messaging/Feed', icon: 'message-bubbles' },
  { key: 'leaderboard', label: 'Leaderboard', icon: 'trophy' },
  { key: 'reporting', label: 'Reporting', icon: 'clipboard' },
];

const GroupInfoForm = ({
  values, errors, touched, handleChange, handleBlur, setFieldValue,
}) => {
  const toggleAvailability = (key) => {
    setFieldValue('groupFilters', {
      ...values.groupFilters,
      [key]: !values.groupFilters[key],
    });
  };

  return (
    <FormWrapper>
      <Input
        label='Group Name'
        name='name'
        type='text'
        value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder='Name of Group'
        fontSize='14px'
        height='38px'
        width='100%'
        styledPropsLabel={{ fontWeight: 700 }}
        error={!!(touched.name && errors.name)}
        errorMsg={errors.name || ''}
        right='5px'
        top='38px'
      />

      <Text styledTextProps={{ fontSize: '16px', fontWeight: 700, marginTop: '8px' }}>
        Availability
      </Text>
      <Text styledTextProps={{ fontSize: '13px', color: '#757575' }}>
        Check boxes to enable where group can be used
      </Text>

      <AvailabilityRow>
        {AVAILABILITY_OPTIONS.map(({ key, label, icon }) => {
          const isChecked = !!values.groupFilters[key];
          return (
            <AvailabilitySquare
              key={key}
              type='button'
              isChecked={isChecked}
              onClick={() => toggleAvailability(key)}
              aria-pressed={isChecked}
            >
              <AvailabilityIconBadge isChecked={isChecked}>
                <Icon icon={icon} size={20} color={isChecked ? '#0DCC8A' : '#1A1A1A'} />
              </AvailabilityIconBadge>
              <Text styledTextProps={{
                fontSize: '11px', fontWeight: 600, color: '#1A1A1A',
              }}
              >
                {label}
              </Text>
              <CheckCircle isChecked={isChecked}>
                {isChecked && <Icon icon='checkmark' size={16} color='#FFFFFF' />}
              </CheckCircle>
            </AvailabilitySquare>
          );
        })}
      </AvailabilityRow>
    </FormWrapper>
  );
};

GroupInfoForm.propTypes = {
  values: PropTypes.shape({
    name: PropTypes.string,
    groupFilters: PropTypes.shape({
      messaging: PropTypes.bool,
      leaderboard: PropTypes.bool,
      reporting: PropTypes.bool,
    }),
  }).isRequired,
  errors: PropTypes.instanceOf(Object),
  touched: PropTypes.instanceOf(Object),
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

GroupInfoForm.defaultProps = {
  errors: {},
  touched: {},
};

export default GroupInfoForm;
